import { Modal } from 'bootstrap';
import Service from "./common/services/Service";

class SessionTimer extends Service {
    timeoutInterval: number = 90000;
    secondsForWarning: number = null;
    secondsBeforeLogout: number = null;
    ajaxData: object;
    sentAlert = false;
    timer: any = null;
    timeout: any = null;
    lastSavedTime: any;

    constructor() {
        super();
        this.ajaxData = {
            authenticity_token: this.csrfToken()
        };
    }

    private checkTimeout = () => {
        // console.log(this);
        try {
            if ((this.secondsBeforeLogout && this.lastSavedTime) && ((Date.now() - this.lastSavedTime) > (this.secondsBeforeLogout * 1000) + 1000)) {
                clearInterval(this.timer);
                window.location.href = document.location.origin;
            } else {
                $.ajax({
                    url: '/check_time_until_logout',
                    type: 'GET',
                    dataType: 'json',
                    data: this.ajaxData,
                    error: (jqXHR, exception) => {
                        if (jqXHR.status == 401) {
                            clearInterval(this.timer);
                            window.location.href = document.location.origin
                        }
                    }
                }).then((d) => {
                    this.secondsBeforeLogout = d;
                    this.lastSavedTime = Date.now();
                    console.log("seconds until timeout: ", this.secondsBeforeLogout);
                    if (this.secondsBeforeLogout < this.secondsForWarning && !this.sentAlert) {
                        clearInterval(this.timer);
                        const timeoutModalElement = document.querySelector<HTMLElement>('.session-timeout-modal');
                        if (timeoutModalElement) {
                            Modal.getOrCreateInstance(timeoutModalElement).show();
                        }
                        this.sentAlert = true;
                        this.timeout = setTimeout(() => {
                            window.location.href = document.location.origin
                        }, d * 1000)
                    }
                });
            }
        }
        catch (error) {
            console.error(error);
        }

    };

    public initTimer = () => {
        const timeoutModal: JQuery = $('.session-timeout-modal');
        if (timeoutModal.length) {
            this.secondsBeforeLogout = null;
            this.lastSavedTime = null;
            this.checkTimeout();
            this.timer = setInterval(this.checkTimeout, this.timeoutInterval);
            timeoutModal.off().on('hidden.bs.modal', () => {
                this.sentAlert = false;
            });
        }
    };

    public resetTimer = () => {
        console.log('resetting timer');
        if ((this.secondsBeforeLogout && this.lastSavedTime) && ((Date.now() - this.lastSavedTime) > (this.secondsBeforeLogout * 1000) + 1000)) {
            window.location.href = document.location.origin;
        }
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        this.resetSession();
        this.secondsBeforeLogout = null;
        this.lastSavedTime = null;
        // this.checkTimeout();
        this.timer = setInterval(this.checkTimeout, this.timeoutInterval);
    };

    public resetSession = () => {
        $.ajax({
            url: '/reset_session_timeout',
            type: 'GET',
            dataType: 'json',
            data: this.ajaxData,
            error: (jqXHR, exception) => {
                if (jqXHR.status == 401) {
                    window.location.href = document.location.origin
                }
            }
        }).done((d)=> {
            this.secondsBeforeLogout = d;
            this.lastSavedTime = Date.now();
            console.log(this.secondsBeforeLogout);
        });
    };

    public resetAfterAjaxSuccess = (lastSavedTime, secondsBeforeLogout) => {
        console.log('setting times for timer');
        this.lastSavedTime = lastSavedTime;
        this.secondsBeforeLogout = secondsBeforeLogout;
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        this.timer = setInterval(this.checkTimeout, this.timeoutInterval);
    };


    public reset = () => {
        if (this.timer) {
            clearInterval(this.timer);
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.initTimer();
        this.sentAlert = false;
    }
}

const sessionTimer = new SessionTimer();
export default sessionTimer;

sessionTimer.initTimer();

$(document).on('turbo:load', () => {
    sessionTimer.reset();

    $('.session-timeout-modal').on('hide.bs.modal', () => {
        sessionTimer.resetTimer();
    });
});
